<template>
  <div ref="layout" class="page-query">
    <TableQuery title="客户主数据批导" :tools="false">
      <el-form inline class="form" size="mini" label-width="100px">
        <el-row>
          <el-col :span="8">
            <el-form-item class="widget-view" label="批导类型" label-width="80">
              <el-select
                v-model="conditions.templateCode"
                placeholder="请选择"
                type="select"
                clearable
                @change="conditionChanged"
              >
                <el-option
                  v-for="item in selectTypes"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="16" class="download">
            <el-dropdown @command="downloadTemplate">
              <div class="tempDownload">
                <img src="@/assets/images/excel@3x.png" alt="">
                <span class="el-dropdown-link">
                  模版下载
                </span>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="item in selectTypes"
                  :key="item.id"
                  :command="{
                    type: item.id,
                    fileName: item.fileName
                  }"
                >{{ item.label }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-col>
        </el-row>
      </el-form>
    </TableQuery>

    <div class="table-container">
      <TableCommon title="批导数据" :custome-config="() => vxeShowCustom('xTable')">
        <template #button>
          <table-button
            v-for="btn in gridOptions.buttons"
            :key="btn.label"
            :name="btn.icon"
            :tip="btn.label"
            @click="tableEvent(btn)"
          />
        </template>
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="auto"
          max-height="500"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        />
      </TableCommon>
    </div>
  </div>
</template>
<script>
import { apiExportExcelTemplate, apiExcelImport, apiGetExcelImportData } from '@/api/common'
import { getToken } from '@/utils/auth'
import { DOWNLOAD_API } from '@/api/baseUrl'
import { apiClientImport } from '@/api/sap/client-sap'

export default {
  data() {
    return {
      conditions: {
        templateCode: 'clientDataBasicImport',
        batchNumber: ''
      },
      selectTypes: [
        {
          id: 'clientDataBasicImport',
          name: '客户主数据基本信息',
          label: '客户主数据基本信息模板下载',
          fileName: '客户主数据批导-基本信息_V1.0'
        },
        {
          id: 'clientDataYxdyImport',
          name: '客户营销单元',
          label: '客户销售单元批量导入模板',
          fileName: '客户主数据批导-客户所属营销单元_V1.0'
        },
        {
          id: 'clientDataAddressImport',
          name: '客户地址信息',
          label: '客户地址信息导入模板',
          fileName: '客户主数据批导-地址信息_V1.0'
        },
        {
          id: 'clientDataRelationImport',
          name: '客户关系信息',
          label: '客户关系信息导入模板',
          fileName: '客户主数据批导-客户关系_V1.0'
        },
        {
          id: 'clientDataCansaleImport',
          name: '客户可售产品信息',
          label: '客户可售产品信息导入模板',
          fileName: '客户主数据批导-客户可售产品信息_V1.0'
        },
        {
          id: 'clientDataStaff',
          name: '员工主数据',
          label: '员工主数据信息导入模板',
          fileName: '客户主数据批导-员工主数据_V1.0'
        },
        {
          id: 'clientDataRelationDelImport',
          name: '客户关系删除',
          label: '客户关系删除导入模版',
          fileName: '客户关系删除导入模版'
        },
        {
          id: 'clientDataCansaleDelImport',
          name: '客户可售产品删除',
          label: '客户可售产品删除导入模版',
          fileName: '客户可售产品删除导入模版'
        },
        {
          id: 'clientDataYxdyDelImport',
          name: '客户营销单元删除',
          label: '客户营销单元删除导入模版',
          fileName: '客户营销单元删除导入模版'
        },
        {
          id: 'clientDataAddressImport2',
          name: '客户地址删除',
          label: '客户地址删除导入模板',
          fileName: '客户地址批量删除导入模版'
        }
      ],
      loading: false,
      gridOptions: {
        buttons: [
          {
            label: '导入',
            style: 'primary',
            icon: 'import',
            type: 'custom',
            code: 'import'
          },
          {
            label: '保存',
            style: 'primary',
            icon: 'save',
            type: 'custom',
            code: 'save'
          }
        ],
        columns: [],
        data: []
      },
      // 基本信息
      gridOptions0: {
        columns: [
          { field: 'ICON', title: '状态', width: 120 },
          { field: 'PARTNER', title: '客户编号', width: 120 },
          { field: 'NAME_ORG1', title: '客户名称', width: 120 },
          { field: 'ZZFLD000016', title: '客户类型', width: 120 },
          { field: 'ZZFLD000018', title: '法人姓名', width: 120 },
          { field: 'ZZFLD000019', title: '法人电话', width: 120 },
          { field: 'ZZFLD00001A', title: '统一社会信用代码', width: 140 },
          { field: 'ZZFLD00001B', title: '工商登记号', width: 120 },
          { field: 'ZZFLD00001C', title: '营销管理编码', width: 120 },
          { field: 'PARTNER_EMP', title: '员工手机号', width: 120 },
          { field: 'RLTYP', title: '是否订单客户', width: 120 },
          { field: 'RLTYP_KP', title: '是否开票客户', width: 120 },
          { field: 'TAXTYPE', title: '发票类型', width: 120 },
          { field: 'ZZFLD000022', title: '开户行', width: 120 },
          { field: 'ZZFLD000023', title: '银行账号', width: 120 },
          { field: 'ZZFLD00003D', title: '历史创建日期', width: 120 },
          { field: 'ZZFLD000026', title: '归档标识', width: 120 },
          { field: 'TEXT', title: '增值税登记号', width: 120 }
        ]
      },
      // 营销单元
      gridOptions1: {
        columns: [
          { field: 'ICON', title: '状态' },
          { field: 'PARTNER', title: '客户编号' },
          { field: 'ZZFLD00001H', title: '营销单元编号' },
          { field: 'ZZFLD00003E', title: '基地编号' }
        ]
      },
      // 地址
      gridOptions2: {
        columns: [
          { field: 'ICON', title: '状态', width: 120 },
          { field: 'PARTNER', title: '客户编码', width: 120 },
          { field: 'NAME1', title: '联络人姓名', width: 120 },
          { field: 'ZZFLD000027', title: '身份证号', width: 120 },
          { field: 'EXT_NUMBER', title: '固定电话', width: 120 },
          { field: 'TEL_NUMBER', title: '手机号码', width: 120 },
          { field: 'FAX_NUMBER', title: '传真号码', width: 120 },
          { field: 'BRAND', title: '品牌（生产计划）', width: 120 },
          { field: 'COUNTRY', title: '国家', width: 120 },
          { field: 'REGION', title: '省份', width: 120 },
          { field: 'CITY_CODE', title: '城市', width: 120 },
          { field: 'STREETCODE', title: '区县', width: 120 },
          { field: 'STREET', title: '详细地址', width: 120 },
          { field: 'POST', title: '邮编', width: 120 },
          { field: 'ADR_KIND', title: '地址类别', width: 120 },
          { field: 'ADR_REMARK', title: '备注', width: 120 }
        ]
      },
      // 关系
      gridOptions3: {
        columns: [
          { field: 'ICON', title: '状态' },
          { field: 'PARTNER1', title: '关系客户1编号' },
          { field: 'PARTNER2', title: '关系客户2编号' },
          { field: 'RELTYP', title: '关系类型编号' }
        ]
      },
      // 可售产品
      gridOptions4: {
        columns: [
          { field: 'ICON', title: '状态' },
          { field: 'PARTNER', title: '客户编号' },
          { field: 'PRODUCT_ID', title: '产品编码' }
        ]
      },
      // 员工
      gridOptions5: {
        columns: [
          { field: 'ICON', title: '状态' },
          { field: 'MANDT', title: '集团' },
          { field: 'NAME_LAST', title: '员工姓' },
          { field: 'NAME_FIRST', title: '员工名' },
          { field: 'ZZFLD00002R', title: '员工手机号' },
          { field: 'DATUM', title: '创建日期' },
          { field: 'UZEIT', title: '创建时间' },
          { field: 'UNAME', title: '创建人名称' }
        ]
      }
    }
  },
  created() {
    this.gridOptions.columns = this.gridOptions0.columns
  },
  methods: {
    // 模板下崽
    async downloadTemplate({ type, fileName }) {
      if (type === 'clientDataAddressImport2') {
        type = 'clientDataAddressImport'
      }
      const res = await apiExportExcelTemplate(type)

      if (res?.status !== 0) {
        return
      }

      const url = `${DOWNLOAD_API()}/attachment/downFileByTmpdir.ajax?file=${
        res.data.file
      }&authToken=${getToken()}&fileName=${fileName}`
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.target = '_blank'
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    },
    conditionChanged(value) {
      switch (this.conditions.templateCode) {
        case 'clientDataBasicImport':
          this.gridOptions.columns = this.gridOptions0.columns
          break
        case 'clientDataYxdyImport':
        case 'clientDataYxdyDelImport':
          this.gridOptions.columns = this.gridOptions1.columns
          break
        case 'clientDataAddressImport':
        case 'clientDataAddressImport2':
          this.gridOptions.columns = this.gridOptions2.columns
          break
        case 'clientDataRelationImport':
        case 'clientDataRelationDelImport':
          this.gridOptions.columns = this.gridOptions3.columns
          break
        case 'clientDataCansaleImport':
        case 'clientDataCansaleDelImport':
          this.gridOptions.columns = this.gridOptions4.columns
          break
        case 'clientDataStaff':
          this.gridOptions.columns = this.gridOptions5.columns
          break
      }
      this.gridOptions.data = []
    },
    tableEvent(btn) {
      switch (btn.code) {
        case 'import':
          this.handleImportExcel()
          break
        case 'save':
          this.handleSaveImportExcel()
          break
      }
    },
    // 导入excel
    async handleImportExcel() {
      this.$refs.xTable
        .readFile({
          types: ['xlsx']
        })
        .then(async resp => {
          const { files } = resp
          const formData = new FormData()
          Array.from(files).forEach(file => {
            formData.append('file', file)
          })
          const params = {
            formData,
            templateCode: this.conditions.templateCode === 'clientDataAddressImport2' ? 'clientDataAddressImport' : this.conditions.templateCode
          }
          const res = await apiExcelImport(params)
          if (res?.status === 1) {
            this.conditions.batchNumber = res.data
            this.handleQueryImportExcel(res.data)
          }
        })
    },
    // 查询导入excel数据
    async handleQueryImportExcel() {
      const params = { ...this.conditions, page: 1, pagesize: 1000 }
      params.templateCode === 'clientDataAddressImport2' && (params.templateCode = 'clientDataAddressImport')
      const res = await apiGetExcelImportData(params)
      for (const item of res.data.Rows) {
        Object.keys(item).forEach(key => {
          item[this.toLineAndUp(key)] = item[key]
          delete item[key]
        })
      }
      // sap 检查数据
      this.checkDataAndSave(res.data.Rows, 'X')
    },
    async checkDataAndSave(data, check) {
      const types = {
        clientDataBasicImport: 'INFO',
        clientDataYxdyImport: 'YXDY',
        clientDataRelationImport: 'RELATION',
        clientDataAddressImport: 'ADDRESS',
        clientDataCansaleImport: 'PRO',
        clientDataStaff: 'STAFF'
      }
      const delTypes = {
        clientDataYxdyDelImport: {
          mode: 'YXDY_DEL',
          field: 'YXDY'
        },
        clientDataCansaleDelImport: {
          mode: 'PRO_DEL',
          field: 'PRO'
        },
        clientDataAddressImport2: {
          mode: 'ADDRESS_DEL',
          field: 'ADDRESS'
        },
        clientDataRelationDelImport: {
          mode: 'RELATION_DEL',
          field: 'RELATION'
        }
      }
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        role: this.$store.getters.role.ROLE,
        mode: types[this.conditions.templateCode] || delTypes[this.conditions.templateCode].mode,
        check: check,
        [types[this.conditions.templateCode] || delTypes[this.conditions.templateCode].field]: data || this.gridOptions.data
      }
      const res = await apiClientImport(params)
      if (res.MSGTYPE === 'S') {
        this.gridOptions.data = res.DATA[types[this.conditions.templateCode] || delTypes[this.conditions.templateCode].field]
        if (!check) {
          return this.$message.success({
            message: res.MESSAGE,
            showClose: true,
            duration: 6000
          })
        }
      } else {
        this.$message.warning({
          message: res.MESSAGE,
          showClose: true,
          duration: 6000
        })
      }
    },
    handleSaveImportExcel() {
      this.checkDataAndSave()
    },
    // 驼峰转成下划线并且大写
    toLineAndUp(str = '') {
      return str.replace(/([A-Z])/g, '_$1').toUpperCase()
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  padding: 0 20px 20px;
  background: #ffffff;
}
.download {
  text-align: right;
  line-height: 36px;
  font-size: 14px;
  .tempDownload {
    display: flex;
    align-items: center;
    img {
      display: inline-block;
      width: 14px;
      height: 14px;
      margin-right: 8px;
    }
    span {
      font-size: 14px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/client-manage/clientDataImport.vue